// Keep in sync with ContactMessage::RECIPIENTS["general"].
export const CONTACT_EMAIL = "hello@pagepledge.com";

export function contactMailto(subject) {
  return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}`;
}
